import React, { Component } from 'react';
import styled from 'styled-components';

const DropDownContainer = styled("div")`
`;

const DropDownHeader = styled("div")`
	border: 1px solid black;
	text-align: center;
	width: 100px;
`;

const DropDownListContainer = styled("div")`
	box-shadow: 5px 10px #88888888;
	z-index: 1000;
	position: absolute;
`;

const ListItem = styled("div")`
	border: 1px solid black;
	text-align: center;
	width: 100px!important;
	display: inline-block;
`;

class ColorPicker extends Component {
	static colors = [
		"#ffffff",
		"#cccccc",
		"#888888",
		"#444444",
		"#000000",
		"#ffcccc",
		"#ff8888",
		"#ff4444",
		"#ccffcc",
		"#88ff88",
		"#44ff44",
		"#ccccff",
		"#8888ff",
		"#4444ff",
		"#ffffcc",
		"#ffff88",
		"#ffff44",
		"#ccffff",
		"#88ffff",
		"#44ffff",
		"#ffccff",
		"#ff88ff",
		"#ff44ff",
		"#ff00ff"
	];

	show() {
		this.setState({ toggling: true });
		window.addEventListener(
			'mouseup',
			(e) => {
				let col = e.target.getAttribute("data-color");
				this.setState({ toggling: false });
				if (col) {
					this.props.callback(col);
				}
				return false;
			},
			{
				once: true
			}

		);
	};

	render() {
		return (
			<DropDownContainer>
				<DropDownHeader
					onClick={() => this.show()}
					style={{ backgroundColor: this.props.color }}>
					color
				</DropDownHeader>
				{this.state?.toggling && (
					<DropDownListContainer>
						{ColorPicker.colors.map((option, index) => (
							<React.Fragment key={index}>
								<ListItem
									data-color={option}
									style={{ backgroundColor: option }}>
									{option}
								</ListItem>
								{index % 4 === 3 ? <br /> : ""}
							</React.Fragment>
						))}
					</DropDownListContainer>
				)}
			</DropDownContainer>
		);
	}
}

export default ColorPicker;